import React, { PropsWithChildren, useRef } from 'react';

import { bootstrapCookieConsentMode } from './bootstrapCookieConsentMode';
import { CookieConsentBanner } from './CookieConsentBanner';
import { CookieConsentProvider } from './CookieConsentProvider';

interface ICookieConsentProps {
    isEnabled?: boolean;
}

export function CookieConsent({ children, isEnabled }: PropsWithChildren<ICookieConsentProps>) {
    const bootstrapped = useRef(false);
    if (isEnabled === true && !bootstrapped.current) {
        bootstrapped.current = true;
        bootstrapCookieConsentMode();
    }

    if (isEnabled !== true) {
        return children;
    }

    return (
        <CookieConsentProvider>
            {children}
            <CookieConsentBanner />
        </CookieConsentProvider>
    );
}
